import { render, staticRenderFns } from "./SidebarItemHeader.vue?vue&type=template&id=45e99b7c&"
import script from "./SidebarItemHeader.vue?vue&type=script&lang=js&"
export * from "./SidebarItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports